import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SimpleGrid,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../../Components/Common/CustomModal/CustomModal";
import AddNewCaseForm from "./AddNewCaseForm";
import EdssSearch from "./EdssSearch";
const CaseLinksBox = ({ data }) => {
  const { onOpen, isOpen, onClose } = useDisclosure();
  const {
    onOpen: onNewCaseOpen,
    isOpen: isNewCaseOpen,
    onClose: onNewCaseClose,
  } = useDisclosure();
  const navigate = useNavigate();
  const handleNavigation = (caseItem) => {
    navigate(`/CaseView/${caseItem?.id?.VALUE}/${caseItem?.PERSON_ID?.VALUE}`);
  };

  return (
    <Box>
      <SimpleGrid spacing={4} columns={{ base: 1, md: 4 }}>
        {data?.map((caseinfo, idx) => {
          console.log("====", caseinfo);
          const { FIRST_NAME, LAST_NAME, PRODUCT, LINK_TYPE } = caseinfo;
          return (
            <Box
              borderWidth="1px"
              borderRadius="lg"
              p={2}
              boxShadow="md"
              cursor="pointer"
              _hover={{
                transform: "scale(1.05)",
                boxShadow: "lg",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onClick={() => handleNavigation(caseinfo)}
            >
              <Box>
                <Flex
                  alignItems="center"
                  justifyContent="space-evenly"
                  fontSize="sm"
                >
                  <Box textAlign="left" w="40%" fontSize="sm">
                    Name
                  </Box>
                  <Box textAlign="center"> : </Box>
                  <Box textAlign="left" width="60%" ml={4} fontSize="sm">
                    <Text>
                      {FIRST_NAME?.VALUE} {LAST_NAME?.VALUE}
                    </Text>
                  </Box>
                </Flex>
                <Flex
                  alignItems="center"
                  justifyContent="space-evenly"
                  fontSize="sm"
                >
                  <Box textAlign="left" w="40%" fontSize="sm">
                    Event Type
                  </Box>
                  <Box textAlign="center"> : </Box>
                  <Box textAlign="left" width="60%" ml={4} fontSize="sm">
                    <Text>{PRODUCT?.VALUE}</Text>
                  </Box>
                </Flex>
                <Flex
                  alignItems="center"
                  justifyContent="space-evenly"
                  fontSize="sm"
                >
                  <Box textAlign="left" w="40%" fontSize="sm">
                    Link Type
                  </Box>
                  <Box textAlign="center"> : </Box>
                  <Box textAlign="left" width="60%" ml={4} fontSize="sm">
                    <Text>{LINK_TYPE?.VALUE}</Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
          );
        })}
        <Box
          borderWidth="1px"
          borderRadius="lg"
          p={2}
          //   boxShadow="md"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Menu>
            <MenuButton
              px={4}
              py={2}
              transition="all 0.2s"
              borderRadius="md"
              borderWidth="1px"
              //   _hover={{ bg: "gray.400" }}
              _expanded={{ bg: "gray.100" }}
              _focus={{ boxShadow: "outline" }}
            >
              Add New <ChevronDownIcon />
            </MenuButton>
            <MenuList>
              <MenuItem onClick={() => onNewCaseOpen()}> Create New</MenuItem>
              <MenuItem onClick={() => onOpen()}>Link to</MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </SimpleGrid>

      {/* ========================= */}
      <CustomModal
        size="6xl"
        isCentered={true}
        // title="Search Edss"
        isOpen={isOpen}
        onClose={onClose}
        bodyContent={<EdssSearch onClose={onClose} />}
      />
      <CustomModal
        size="6xl"
        isCentered={true}
        // title="Link To New"
        isOpen={isNewCaseOpen}
        onClose={onNewCaseClose}
        bodyContent={<AddNewCaseForm />}
      />
    </Box>
  );
};

export default CaseLinksBox;
